import { network } from 'services/network';

export const changeCardLane = (params) => {
    return network.post('api/bo/changeCardLane', params).then((response) => {
        return response.data;
    });
};
